import { render } from "./EvalvationNewQuestionnaire.vue?vue&type=template&id=db7e9278"
import script from "./EvalvationNewQuestionnaire.vue?vue&type=script&lang=js"
export * from "./EvalvationNewQuestionnaire.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__